import { z } from 'zod';
import { workPatrolAdditionalRiskV3Schema } from './work-aggregate-v3.js';

const point = z.object({ x: z.number().min(0).max(1), y: z.number().min(0).max(1) }).strict();
export const workDayCommandSchema = z.discriminatedUnion('action', [
  z.object({ action: z.literal('renew') }).strict(),
  z.object({ action: z.literal('attendance'), workers: z.array(z.object({
    workerId: z.string().regex(/^[a-zA-Z0-9_-]{1,80}$/), name: z.string().trim().min(1).max(80),
  }).strict()).min(1).max(200), tbmNote: z.string().trim().max(4000) }).strict(),
  z.object({ action: z.literal('patrol'), checks: z.array(z.object({
    itemId: z.string().min(1).max(160), result: z.enum(['normal', 'action-required', 'not-applicable']),
  }).strict()).max(300),
    additionalRisks: z.array(workPatrolAdditionalRiskV3Schema).max(300).optional(),
    note: z.string().trim().max(2000), correction: z.string().trim().max(2000) }).strict(),
  z.object({ action: z.literal('sign'), workerId: z.string().min(1).max(80),
    confirmed: z.literal(true), strokes: z.array(z.array(point).min(2).max(2000)).min(1).max(100),
  }).strict(),
  z.object({ action: z.literal('close'), housekeeping: z.literal(true), allWorkersExited: z.literal(true),
    residualHazards: z.enum(['none', 'recorded']), facilityDamage: z.enum(['none', 'recorded']),
    note: z.string().trim().max(4000),
  }).strict(),
]);
export type WorkDayCommand = z.infer<typeof workDayCommandSchema>;
export type WorkDayActor = { uid: string; name: string; safetyManager: boolean; canWrite: boolean };
export type WorkDayRecord = {
  workId: string; day: string; version: number; sourceHash: string;
  permit: { approvedAt: string; approvedBy: string; receiptId: string };
  tbmNote: string;
  workers: { workerId: string; name: string; signature?: {
    strokes: z.infer<typeof point>[][]; signedAt: string; recordedBy: string; receiptId: string;
  } }[];
  closeout?: { housekeeping: true; allWorkersExited: true; residualHazards: 'none' | 'recorded';
    facilityDamage: 'none' | 'recorded'; note: string; confirmedAt: string; confirmedBy: string; receiptId: string };
};
